{
  "defaultTitle": "ਚੈੱਕ-ਇਨ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ",
  "defaultMessage": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਡਿਸਪੈਚਰ ਨਾਲ ਜਾਣਕਾਰੀ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ ਜਾਂ ਗੁਦਾਮ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
  "backToHomescreen": "ਹੋਮ ਸਕ੍ਰੀਨ 'ਤੇ ਵਾਪਸ ਜਾਓ",
  "hideErrorLog": "ਐਰਰ ਲੌਗ ਲੁਕਾਓ",
  "viewErrorLog": "ਐਰਰ ਲੌਗ ਵੇਖੋ",
  "errorLogMessageLabel": "ਸੁਨੇਹਾ:",
  "errorLogStatusLabel": "ਸਟੇਟਸ ਕੋਡ:",
  "unknown": "ਅਗਿਆਤ"
}
